import React, { useEffect, useRef, useState } from "react";
import "../../assets/styles/auth/forgotPassword.scss";
import { useNavigate } from "react-router-dom";
import { apiConfirmAccount, apiRegisterStepTwo, apiSetAlert } from "../../api/appApi";
import { useDispatch, useSelector } from "react-redux";
import { formatNumber } from "../../helpers";
import backgroundNewAuth from "../../assets/svg/background-new-auth.svg";
import NewInput from "../../components/simple/NewInput";
import ArrowBackAuth from "../../assets/svg/arrow-back-auth.svg";

export default function ConfirmAccount() {
  const [toggleEmailCode, setToggleEmailCode] = useState(false);
  const [toggleMobileCode, setToggleMobileCode] = useState(false);
  const [showEmail, setShowEmail] = useState(true);
  const [showPhone, setShowPhone] = useState(true);
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();

  const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);
  const user = useSelector((state) => state).appReducer.user;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [phoneTimer, setPhoneTimer] = useState(0);
  const [emailTimer, setEmailTimer] = useState(0);
  const [digitOne, setDigitOne] = useState("");
  const [digitTwo, setDigitTwo] = useState("");
  const [digitThree, setDigitThree] = useState("");
  const [digitFour, setDigitFour] = useState("");
  const [digitFive, setDigitFive] = useState("");
  const [digitSix, setDigitSix] = useState("");

  const refDigitOne = useRef(null);
  const refDigitTwo = useRef(null);
  const refDigitThree = useRef(null);
  const refDigitFour = useRef(null);
  const refDigitFive = useRef(null);
  const refDigitSix = useRef(null);

  useEffect(() => {
    if (phoneTimer > 0) {
      setTimeout(() => {
        setPhoneTimer(phoneTimer - 1);
      }, 1000);
    }
  }, [phoneTimer]);

  useEffect(() => {
    if (emailTimer > 0) {
      setTimeout(() => {
        setEmailTimer(emailTimer - 1);
      }, 1000);
    }
  }, [emailTimer]);

  useEffect(() => {
    if (user) {
      setEmail(user.email);
      setPhone(user.phone);
    }
  }, []);

  const submitRegisterTwoEmail = () => {
    let inputFields = {};
    setEmailTimer(120);
    inputFields["email"] = email;
    setToggleEmailCode(!toggleEmailCode);
    dispatch(apiRegisterStepTwo(inputFields, user.token));
  };

  const submitRegisterTwoPhone = () => {
    let inputFields = { phone: phone };
    setPhoneTimer(120);
    setToggleMobileCode(true);
    dispatch(apiRegisterStepTwo(inputFields, user.token));
  };

  const confirmAccount = (sixthNumber = digitSix, isEmail) => {
    if (digitOne && digitTwo && digitThree && digitFour && digitFive && sixthNumber) {
      let verifyCodePhone = digitOne + digitTwo + digitThree + digitFour + digitFive + sixthNumber;
      dispatch(apiConfirmAccount({ verifyCodePhone }, user, navigate));
    } else {
      dispatch(apiSetAlert("لطفا کد را به صورت کامل وارد نمایید", "warning"));
    }
  };

  const funcEmail = (e) => {
    setEmail(e.target.value);
  };

  const funcPhone = (e) => {
    setPhone(e.target.value);
  };

  return (
    <>
      <img src={backgroundNewAuth} alt="backgroundNewAuth" className="background-new-auth" />
      <div className="d-flex flex-column">
        <div className="wrap-confirm-password">
          <form>
            <h5>تایید حساب کاربری</h5>
            <p>حساب کاربری شما تایید نشده است. لطفا اطلاعات تماس خود را تایید نمایید</p>
            <div className="row">
              {user?.email && 1 === 2 ? (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                      <NewInput
                        deleteIcon={true}
                        editIcon={true}
                        label={"ایمیل شما"}
                        type={"email"}
                        disabled={showEmail}
                        value={email}
                        showValue={showEmail}
                        editInput={setShowEmail}
                        onChange={(e) => funcEmail(e)}
                        // onChange={(e) =>
                        //   setInputFields((prev) => {
                        //       prev.main.nickName = e.target.value;
                        //       forceUpdate();
                        //       return prev;
                        //   })
                        // }
                      />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                      {toggleMobileCode ? (
                        <button
                          className={
                            phoneTimer === 0 ? "btn-send-code-confirm small" : "btn-send-code-confirm-timer"
                          }
                          style={{ marginTop: 42 }}
                          type="button"
                          onClick={() => {
                            if (phoneTimer === 0) {
                              submitRegisterTwoEmail();
                            }
                          }}
                        >
                          {phoneTimer > 0 ? (
                            <div style={{ color: "#000000" }}>
                              0{parseInt(phoneTimer / 60)}:
                              {phoneTimer % 60 > 9 ? phoneTimer % 60 : "0" + (phoneTimer % 60)}
                            </div>
                          ) : (
                            <>درخواست مجدد</>
                          )}
                        </button>
                      ) : (
                        <button
                          className="btn-send-code-confirm small"
                          style={{ marginTop: 42 }}
                          type="button"
                          onClick={() => submitRegisterTwoEmail()}
                        >
                          ارسال کد تایید
                        </button>
                      )}
                    </div>
                  </div>
                  {toggleEmailCode ? (
                    <div className="p-0 pb-0 row style-wrap-confirm-code" dir="ltr">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label className="label-confrim-code">کد تایید ایمیل</label>
                      </div>
                      <div className="mt-4 col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div className={"wrap-new-input style-new-input-digit"}>
                          <input
                            ref={refDigitOne}
                            value={digitOne}
                            className={
                              digitOne.length > 0
                                ? "c-new-input c-new-input-entered"
                                : "c-new-input c-new-input-empty"
                            }
                            onChange={(e) => {
                              const value = formatNumber(e.target.value).slice(-1);
                              setDigitOne(value);
                              if (value.length > 0) {
                                refDigitTwo.current.focus();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="mt-4 col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div className={"wrap-new-input style-new-input-digit"}>
                          <input
                            ref={refDigitTwo}
                            value={digitTwo}
                            className={
                              digitTwo.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                            }
                            onChange={(e) => {
                              const value = formatNumber(e.target.value).slice(-1);
                              setDigitTwo(value);
                              if (value.length > 0) {
                                refDigitThree.current.focus();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="mt-4 col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div className={"wrap-new-input style-new-input-digit"}>
                          <input
                            ref={refDigitThree}
                            value={digitThree}
                            className={
                              digitThree.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                            }
                            onChange={(e) => {
                              const value = formatNumber(e.target.value).slice(-1);
                              setDigitThree(value);
                              if (value.length > 0) {
                                refDigitFour.current.focus();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="mt-4 col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div className={"wrap-new-input style-new-input-digit"}>
                          <input
                            ref={refDigitFour}
                            value={digitFour}
                            className={
                              digitFour.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                            }
                            onChange={(e) => {
                              const value = formatNumber(e.target.value).slice(-1);
                              setDigitFour(value);
                              if (value.length > 0) {
                                refDigitFive.current.focus();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="mt-4 col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div className={"wrap-new-input style-new-input-digit"}>
                          <input
                            ref={refDigitFive}
                            value={digitFive}
                            className={
                              digitFive.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                            }
                            onChange={(e) => {
                              const value = formatNumber(e.target.value).slice(-1);
                              setDigitFive(value);
                              if (value.length > 0) {
                                refDigitSix.current.focus();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="mt-4 col-lg-2 col-md-2 col-sm-2 col-xs-2">
                        <div className={"wrap-new-input style-new-input-digit"}>
                          <input
                            ref={refDigitSix}
                            value={digitSix}
                            className={
                              digitSix.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                            }
                            onChange={(e) => {
                              const value = formatNumber(e.target.value).slice(-1);
                              setDigitSix(value);
                              if (value.length > 0) {
                                confirmAccount();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 btns">
                        <button
                          type="button"
                          className="btn-enter"
                          onClick={() => confirmAccount()}
                          disabled={sendingRequest}
                        >
                          تایید
                        </button>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : null}
              {user?.phone ? (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                      <NewInput
                        deleteIcon={false}
                        editIcon={true}
                        label={"شماره موبایل شما"}
                        type={"text"}
                        disabled={showPhone}
                        showValue={showPhone}
                        onChange={(e) => funcPhone(e)}
                        value={phone}
                        editInput={setShowPhone}
                      />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                      {toggleMobileCode ? (
                        <button
                          className={
                            phoneTimer === 0 ? "btn-send-code-confirm small" : "btn-send-code-confirm-timer"
                          }
                          style={{ marginTop: 42 }}
                          type="button"
                          onClick={() => {
                            if (phoneTimer === 0) {
                              submitRegisterTwoPhone();
                            }
                          }}
                        >
                          {phoneTimer > 0 ? (
                            <div style={{ color: "#000000" }}>
                              0{parseInt(phoneTimer / 60)}:
                              {phoneTimer % 60 > 9 ? phoneTimer % 60 : "0" + (phoneTimer % 60)}
                            </div>
                          ) : (
                            <>درخواست مجدد</>
                          )}
                        </button>
                      ) : (
                        <button
                          className="btn-send-code-confirm small"
                          type="button"
                          onClick={() => submitRegisterTwoPhone()}
                        >
                          ارسال کد تایید
                        </button>
                      )}
                    </div>
                  </div>
                  {toggleMobileCode ? (
                    <div className="p-0 pb-0 row style-wrap-confirm-code" dir="ltr">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label className="label-confrim-code">کد تایید شماره موبایل</label>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="mt-4 row">
                          <div className="w-auto" style={{ padding: 8 }}>
                            <div className={"wrap-new-input style-new-input-digit"}>
                              <input
                                ref={refDigitOne}
                                value={digitOne}
                                className={
                                  digitOne.length > 0
                                    ? "c-new-input c-new-input-entered"
                                    : "c-new-input c-new-input-empty"
                                }
                                onChange={(e) => {
                                  const value = formatNumber(e.target.value).slice(-1);
                                  setDigitOne(value);
                                  if (value.length > 0) {
                                    refDigitTwo.current.focus();
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="w-auto" style={{ padding: 8 }}>
                            <div className={"wrap-new-input style-new-input-digit"}>
                              <input
                                ref={refDigitTwo}
                                value={digitTwo}
                                className={
                                  digitTwo.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                                }
                                onChange={(e) => {
                                  const value = formatNumber(e.target.value).slice(-1);
                                  setDigitTwo(value);
                                  if (value.length > 0) {
                                    refDigitThree.current.focus();
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="w-auto" style={{ padding: 8 }}>
                            <div className={"wrap-new-input style-new-input-digit"}>
                              <input
                                ref={refDigitThree}
                                value={digitThree}
                                className={
                                  digitThree.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                                }
                                onChange={(e) => {
                                  const value = formatNumber(e.target.value).slice(-1);
                                  setDigitThree(value);
                                  if (value.length > 0) {
                                    refDigitFour.current.focus();
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="w-auto" style={{ padding: 8 }}>
                            <div className={"wrap-new-input style-new-input-digit"}>
                              <input
                                ref={refDigitFour}
                                value={digitFour}
                                className={
                                  digitFour.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                                }
                                onChange={(e) => {
                                  const value = formatNumber(e.target.value).slice(-1);
                                  setDigitFour(value);
                                  if (value.length > 0) {
                                    refDigitFive.current.focus();
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="w-auto" style={{ padding: 8 }}>
                            <div className={"wrap-new-input style-new-input-digit"}>
                              <input
                                ref={refDigitFive}
                                value={digitFive}
                                className={
                                  digitFive.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                                }
                                onChange={(e) => {
                                  const value = formatNumber(e.target.value).slice(-1);
                                  setDigitFive(value);
                                  if (value.length > 0) {
                                    refDigitSix.current.focus();
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="w-auto" style={{ padding: 8 }}>
                            <div className={"wrap-new-input style-new-input-digit"}>
                              <input
                                ref={refDigitSix}
                                value={digitSix}
                                className={
                                  digitSix.length > 0 ? "c-new-input c-new-input-entered" : "c-new-input"
                                }
                                onChange={(e) => {
                                  const value = formatNumber(e.target.value).slice(-1);
                                  setDigitSix(value);
                                  if (value.length > 0) {
                                    confirmAccount(value);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 btns">
                        <button
                          type="button"
                          className="btn-enter"
                          onClick={() => confirmAccount()}
                          disabled={sendingRequest}
                        >
                          تایید
                        </button>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : null}
            </div>
          </form>
        </div>

        <div className="text-center col-lg-12 col-md-12 col-sm-12 col-xs-12 footer">
          <img src={ArrowBackAuth} alt="ArrowBackAuth" />
          <a
            className="me-2"
            onClick={(e) => {
              navigate("/auth/logout");
              e.preventDefault();
            }}
            href="/auth/logout"
          >
            <b>ورود با یک شماره موبایل / ایمیل دیگر</b>
          </a>
        </div>
      </div>
    </>
  );
}
